import React, { useEffect, useRef, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import ErrorMessage from 'components/common/ErrorMessage';
import toast from 'react-hot-toast';
import Api from "services/api"
import { Select } from 'components/common/Select';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import { fetchAssignees } from 'slices/extensionsSlice';
import { fetchExtensions } from 'slices/extensionsSlice';
import { extensionSelector } from 'slices/extensionsSlice';
import { setError } from 'slices/extensionsSlice';
import { updateExtensions } from 'slices/extensionsSlice';
import { addExtensions } from 'slices/extensionsSlice';

const apiService = new Api();

const AddExtensionsForm = ({ item, handleClose, callback, show }) => {
  const dispatch = useDispatch()
  const { register, handleSubmit, watch, formState: { errors }, control, setValue, clearErrors } = useForm({
    defaultValues: {
      extension: '',
      user_id: '',
      password: '',
      status: 'available',
    }
  });
  const { error, loader } = useSelector(extensionSelector);
  const [status, setStatus] = useState(1)
  const [assignees, setAssignees] = React.useState([]);

  const fileInputRef = React.useRef(null);


  const clearAll = () => {
    

    setValue("extension", '');
    setValue("user_id", '');
    setValue("password", '');
    setValue("status", '');
    dispatch(setError({}))
    // clearErrors()
  }

  useEffect(() => {
    dispatch(fetchAssignees({}, (success, message, data) => {
      if (success) {
        setAssignees(data)
      }
    }))
    // code
    if (item?.id) {
      setValue("extension", item?.extension);
      setValue("user_id", item?.user_id ?? "");
      setValue("password", item?.password);
      setValue("status", item?.status);
    } else {
      clearAll()
    }


    return () => clearAll()

  }, [item]);


  useEffect(() => {
    return () => clearAll()
  }, [show])


  const submitCallback = (status, message) => {
    if (status) {
      callback()
      toast.success(message, {
          className:"successToast",
      })
      dispatch(fetchExtensions())
      handleClose()
      clearAll()
    }
    else {
       toast.error(message,
        {
          className:"errorToast",
        }
      );
    }
  };

  const onSubmit = (data) => {
    dispatch(setError({}))
    data = {
      ...data,
      status,
    };
    if (item?.id) {
      dispatch(updateExtensions(data, item?.id, submitCallback));
    } else {
      dispatch(addExtensions(data, submitCallback));
    }
  }

  const assigneesState = React.useMemo(() =>
    assignees?.map(state => {
      const object = {
        value: state.id,
        label: state.name
      }
      return object
    }), [assignees]);

  const filterStatus = [
    {
      value: 'available',
      label: 'available',
    },
    {
      value: 'assigned',
      label: 'assigned',
    }
  ]

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>

        <div className="row-primary">
          <h2>Extensions *</h2>
          <Controller
            name="extension"
            control={control}
            render={({ field }) => <input className="input-in type_inp" type="text" name='extension' placeholder='Extensions code' required {...field} />}
          />
        </div>

        <div className="row-primary">
          <h2>Assigned to *</h2>
          <Controller
            name="user_id"
            control={control}
            rules={{
              required: "Please select a state"
            }}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <Select
                  name="user_id"
                  options={assigneesState || []}
                  {...field}
                  value={assigneesState?.find((opt) => field.value == opt.value)}
                />
                {errors?.user_id?.message &&
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.user_id?.message} />
                  </div>
                }
                {error?.errors?.user_id?.map((error) => (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={error} />
                  </div>
                ))}
              </div>
            }
          />
        </div>

        <div className="row-primary">
          <h2>Password *</h2>
          <Controller
            name="password"
            control={control}
            render={({ field }) =>
              <input className="input-in type_inp" type="password" name='password' placeholder='Password' required {...field} />
            }
          />
        </div>

        <div className="row-primary">
          <h2>Select Status *</h2>
          <Controller
            name="status"
            control={control}
            rules={{
              required: "Please select a status"
            }}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <Select
                  name="status"
                  options={filterStatus || []}
                  {...field}
                  value={filterStatus?.find((opt) => field.value == opt.value)}
                />
              </div>
            }
          />
        </div>





        {error?.errors?.email?.map((error) => (
          <div style={{ marginBottom: 10 }}>
            <ErrorMessage text={error} />
          </div>
        ))}


        {error?.errors?.password?.map((error) => (
          <div style={{ marginBottom: 10 }}>
            <ErrorMessage text={error} />
          </div>
        ))}


        <div className="Form-footer">
          <button type="button" className="Cancle_button" data-bs-dismiss="modal">Cancel</button>
          <SubmitButton
            btnText={item?.id ? "Update" : "Create"}
          />
        </div>
      </form>
    </div>
  )
}

const AddExtensions = ({ item, onClose, callback, show }) => {

  const closeButton = useRef(null)
  const refModal = useRef(null)
  const handleModalDismiss = () => {
    closeButton.current.click()
    onClose()
    // Perform any other actions on modal dismiss
  };
  useEffect(() => {


    const modalElement = refModal.current;

    if (modalElement) {
      // Attach the event listener
      modalElement.addEventListener("hidden.bs.modal", handleModalDismiss);
    }

    return () => {
      if (modalElement) {
        // Clean up the event listener
        modalElement.removeEventListener("hidden.bs.modal", handleModalDismiss);
      }
    };
  }, []);


  return (
    <div class={`modal fade`} ref={refModal} id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" role="dialog">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content full_modal">
          <div className="modal-header header_modal align-items-center">
            <div></div>
            <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Extentions</h5>
            <button onClick={handleModalDismiss} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={closeButton}></button>
          </div>
          <div className="modal-body modal_form_body">
           {show && <AddExtensionsForm item={item} handleClose={handleModalDismiss} callback={callback} show={show} />}
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddExtensions
